import {Component, DestroyRef, effect, Inject, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {
  CurrentAdgroupSelectService,
  CurrentCampaignGroupSelectService, CurrentCampaignGroupSelectSignalService, CurrentCampaignSelectService,
  CurrentCrudSelectBehaviorServiceAsString,
  CurrentSelectedSlugBehaviorService,
  SnackBarService
} from '../objectPassingService';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CampaignGroupsService} from './campaign-groups.service';
import {Subject, takeUntil} from 'rxjs';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {GetAllCampaignGroupPayloadModel} from './campaign_groups_interfaces';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {MatProgressBar, MatProgressBarModule} from '@angular/material/progress-bar';
import { NgClass } from '@angular/common';
import {MatDivider, MatDividerModule} from '@angular/material/divider';
import {MatList, MatListItem, MatListModule} from '@angular/material/list';
import {MatCard, MatCardContent, MatCardModule} from '@angular/material/card';
import {MatButtonModule, MatFabButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput, MatInputModule} from '@angular/material/input';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {MatTooltip} from '@angular/material/tooltip';

/****************************/
import { HighchartsChartModule } from 'highcharts-angular';
import { SeriesTreegraphOptions } from 'highcharts';
import * as Highcharts from 'highcharts';
import 'highcharts/modules/treemap';
import 'highcharts/modules/treegraph';
import 'highcharts/modules/exporting';
/****************************/

export interface CreateCampaignGroupInitPayload {
  is_edit: false;
}



@Component({
  selector: 'app-campaign-groups',
  imports: [
    MatProgressBar,
    MatDivider,
    MatList,
    MatListItem,
    NgClass,
    MatCard,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatFabButton,
    MatFormField,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatPaginator,
    MatRadioButton,
    MatRadioGroup,
    MatRow,
    MatRowDef,
    MatSort,
    MatSortHeader,
    MatTable,
    MatTooltip,
    MatHeaderCellDef,
    HighchartsChartModule,
    MatCardContent
],
  templateUrl: './campaign-groups.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaign-groups.component.css'
})
export class CampaignGroupsComponent implements OnInit, OnDestroy {



  campaignService = inject(CurrentCampaignGroupSelectSignalService);

  Highcharts: typeof Highcharts = Highcharts;
  isDataLoaded = false; // Add this flag
  isDataHhmmLoaded = false; // Add this flag for hh:mm data


  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_loading = true;
  selectedRowIndex: number | null = null;
  client_id: number = 0
  client_slug: string = '';
  campaign_group_sequence_id: string = '';
  data = [];



  dataSource!: MatTableDataSource<GetAllCampaignGroupPayloadModel>;
  displayedColumns: string[] = ['campaign_group_id', 'name', 'campaign_type', 'status', 'View', 'Edit', 'Delete'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    public router: Router, //all components need this
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    public dialog: MatDialog,
    private currentCrudSelectBehaviorServiceAsString: CurrentCrudSelectBehaviorServiceAsString,
    private campaignGroupsService: CampaignGroupsService,
    private currentCampaignGroupSelectService: CurrentCampaignGroupSelectService,
    private currentCampaignSelectService: CurrentCampaignSelectService,
    private currentAdgroupSelectService: CurrentAdgroupSelectService,
  ) {

    effect(() => {
      const id = this.campaignService.clientId$();
      if (id) {
        console.log('EFFECT Campaign ID changed:', id);
        // You can do more here: sync to storage, analytics, etc.
        // const id = this.campaignService.clientId$();
        // if (id) {
        //   localStorage.setItem('campaignClientId', id);
        // }
      }
    });

  } //end constructor

  ngOnInit(): void {

    localStorage.removeItem('campaign_group_id');
    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');

    this.currentCampaignGroupSelectService.announceCampaignGroupSelect('')
    this.currentCampaignSelectService.announceCampaignSelect('')
    this.currentAdgroupSelectService.announceAdgroupSelect('')

    this.client_id = parseInt(localStorage.getItem('client_id') || '0', 10);
    this.client_slug = localStorage.getItem('client_slug') || '';
    this.campaign_group_sequence_id = localStorage.getItem('campaign_group_sequence_id') || '';
    localStorage.removeItem('campaign_group_id');
    console.log('this.client_id',this.client_id)
    console.log('this.client_slug',this.client_slug)
    console.log('this.campaign_group_sequence_id',this.campaign_group_sequence_id)

    if (this.campaign_group_sequence_id) {
      this.getData(false)
    } else {
      this.is_loading = false;
    }


  } //end ngOnInit



  getData(is_mocked:boolean = false) {

    this.is_loading = true;
    const show_deleted = 'false'
    console.log('WTF is_mocked', is_mocked);
    console.log('WTF this.is_loading', this.is_loading);


    this.campaignGroupsService.gets(`adserver/campaign_groups/${this.campaign_group_sequence_id}`, is_mocked).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {

      console.log('WOWEEEEEE!!!',data)

      const jsonString = JSON.stringify(data);
      localStorage.setItem('campaign_group_list', jsonString);


      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.is_loading = false;
      if (data) {
        this.getTree();
      }

      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe
  } //end getData

  getTree(){

    this.campaignGroupsService.getsTree(`adserver/campaign_group/tree/${this.campaign_group_sequence_id}`).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {

        console.log('TREE WOWEEEEEE!!!',data)


        const series = this.chartOptions.series![0] as SeriesTreegraphOptions;
        series.data = data; // Update chart data
        this.isDataLoaded = true; // Set flag to true
        this.getHhmmTree();

      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe

  }

  getHhmmTree(){

    this.campaignGroupsService.getsTree(`adserver/campaign_group/hhmm_tree/${this.campaign_group_sequence_id}`).pipe(takeUntil(this.destroyed)).subscribe( (data: any) => {

        console.log('TREE WTF DUDE!!!',data)


        const series = this.chartHhmmOptions.series![0] as SeriesTreegraphOptions;
        series.data = data; // Update chart data
        this.isDataHhmmLoaded = true; // Set flag to true

      }, (error) => {
        console.log('error', error);
        this.is_loading = false;
      }, () => {
        console.log('complete');
      }
    ) //end subscribe

  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  addCampaignGroup(is_edit: boolean, row?: GetAllCampaignGroupPayloadModel): void {

    localStorage.removeItem('campaigngroupsaved');
    localStorage.removeItem('campaignsaved');
    localStorage.removeItem('adgroupsaved');
    localStorage.removeItem('adsaved');
    if (is_edit && row) {
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(row));
      localStorage.setItem('campaign_group_id', row.campaign_group_id);
    } else {
      const payload: CreateCampaignGroupInitPayload = { is_edit: false };
      this.currentCrudSelectBehaviorServiceAsString.announce(JSON.stringify(payload));
    }
    // Ensure subscribers are ready before navigation
    // It’s faster and cleaner than setTimeout(..., 0).
    queueMicrotask(() => {
      this.router.navigate(
        ['/nav-campaigns', { outlets: { admeta: ['campaign-groups-meta'] } }]
      ).then(() => console.log('Redirected to campaign-groups-meta'));
    });
  }

  getTableRecord(row: object) {
  } // end getTableRecord

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  deleteRow(row: GetAllCampaignGroupPayloadModel){
    console.log('deleteRow', row);

    let campaign_group_id = row.campaign_group_id;
    this.campaignGroupsService.delete(`adserver/campaign_group/${campaign_group_id}`).pipe(takeUntil(this.destroyed)).subscribe(x => {
      console.log(x);
      this.getData(false);
    }, error => {
      console.log('error',error)
    });


  } //end deleteRow

  viewData(row: GetAllCampaignGroupPayloadModel) {
    console.log('viewData', row);
    const campaign_group_id = row['campaign_group_id']
    //this.currentCampaignGroupSelectService.announceCampaignGroupSelect(campaign_group_id);
    localStorage.setItem('campaign_group_id', campaign_group_id);
    localStorage.removeItem('campaign_id');
    localStorage.removeItem('adgroup_id');
    localStorage.removeItem('ad_id');


    localStorage.removeItem('adgroup_name');
    this.currentAdgroupSelectService.announceAdgroupSelect('');
    localStorage.removeItem('campaign_name');
    this.currentCampaignSelectService.announceCampaignSelect('');


    localStorage.setItem('campaign_group_name', row.name);
    this.currentCampaignGroupSelectService.announceCampaignGroupSelect(row.name);

    this.campaignService.announceCampaignGroupSelect(row.name);




    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['campaigns'] } }]).then(r => console.log('redirect to campaigns'));
  } //end viewData(row)

  //data = [{'id': 'campgrp23c9121f097f4bf3bfe9db4283902604', 'parent': 'campgrpe28e8d093ab44073950f3a6768b7617a', 'name': 'Test Campaign Child'},
  //        {'id': 'campgrpe28e8d093ab44073950f3a6768b7617a', 'parent': '', 'name': 'Root'}]

  chartOptions: Highcharts.Options = {
    title: {
      text: 'Campaign Groups Sequence'
    },
    series: [{
      type: 'treegraph',
      keys: ['parent', 'id', 'level'],
      clip: false,
      data: [], // Initialize with an empty array
      marker: {
        symbol: 'rect',
        width: 100,
        fillColor: '#ffffff',
        lineWidth: 3
      }
    }]
  };

  chartHhmmOptions: Highcharts.Options = {
    title: {
      text: 'Campaign Groups'
    },
    chart: {
      inverted: false
    },
    series: [{
      type: 'treegraph',
      keys: ['parent', 'id', 'level'],
      clip: false,
      data: [], // Initialize with an empty array
      marker: {
        symbol: 'rect',
        width: 100,
        fillColor: '#ffffff',
        lineWidth: 3
      }
    }]
  };








  // chartOptions: Highcharts.Options = {
  //   title: {
  //     text: 'Treegraph with box layout'
  //   },
  //   series: [{
  //     type: 'treegraph',
  //     keys: ['parent', 'id', 'level'],
  //     clip: false,
  //     data: this.data,
  //     marker: {
  //       symbol: 'rect',
  //       width: 100,
  //       fillColor: '#ffffff',
  //       lineWidth: 3
  //     }
  //   }]
  // };



} //end CampaignGroupsComponent

